import React from "react";
import { Flex } from "../../components/Flex";
import { Title } from "../../components/Text";
import { BackIcon } from "../../icons/BackIcon";
import { IconButton } from "../../icons/IconContainer";
import { PAGE_SIZE } from "../../settings";

const PaginationButton = ({ onClick, children, selected, ...props}) => (
    <IconButton
        background={selected ? "var(--sp-disabled-text-color)" : "#FFFFFF"}
        color="var(--sp-main-color)"
        onClick={onClick}
        {...props}
    >
        {children}
    </IconButton>
);

const DOTS = "...";

const PageContentPagination = ({ page, total, changePage }) => {
    const pageCount = Math.ceil(total / PAGE_SIZE), pageNumber = 6;

    const range = (start, end) => {
        let length = end - start + 1;
        return Array.from({ length }, (_, idx) => idx + start);
    }

    const renderPagination = (currentPage) => {
        // 1. If the number of pages is less than the page numbers to show return [1..total]
        if (pageNumber >= pageCount) {
            return range(1, pageCount);
        };

        // calculate left and right sibling index
        const leftSibling = Math.max(page - 1, 1);
        const rightSibling = Math.min(currentPage + 1, pageCount);
        const showLeftDots = leftSibling > 2;
        const showRightDots = rightSibling < pageCount - 2;
        const firstPage = 1;
        const lastPage = pageCount;

        // 2. No left dots
        if (!showLeftDots && showRightDots) {
            return [...range(1, 3), DOTS, pageCount];
        };

        // 3. No right dots
        if (showLeftDots && !showRightDots) {
            return [firstPage, DOTS, ...range(pageCount - 3, pageCount)]
        };

        // 4. Both left and right dots
        if (showLeftDots && showRightDots) {
            return [firstPage, DOTS, ...range(leftSibling, rightSibling), DOTS, lastPage];
        };
    };

    return(
        total
            ? <Flex width="calc(50% + 35px)" justify="space-between" align="center" gap={{ right: 24 }}>
                <Title color="var(--sp-label-color)">
                    {page * PAGE_SIZE - PAGE_SIZE + 1}-{page * PAGE_SIZE < total ? page * PAGE_SIZE : total } of {total}
                </Title>
                <Flex gap={{ right: 12 }}>
                    <PaginationButton onClick={() => changePage(page - 1)} disabled={page <= 1}>
                        <BackIcon />
                    </PaginationButton>
                    {renderPagination(page).map((pageNum, idx) => {
                        if (pageNum === DOTS) {
                            return (
                                <PaginationButton key={`dots-${idx}`}>...</PaginationButton>
                            );
                        };
                        return(
                            <PaginationButton
                                key={pageNum}
                                selected={pageNum == page}
                                onClick={() => pageNum != page && changePage(pageNum)}
                            >
                                {pageNum}
                            </PaginationButton>
                        )
                    })}

                    <PaginationButton onClick={() => changePage(page + 1)} disabled={page >= pageCount}>
                        <BackIcon rotate={180} />
                    </PaginationButton>
                </Flex>
            </Flex>
            : null
    );
};

export { PageContentPagination };